import { EditItem, IEditItem } from "../common/editItem";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IInstantMessageChannelEditItem extends IEditItem {
    companyId: string;
    code: string;
    picture: string;
    comment: string;
    messageExpirationTime: number;
    internalChannel: boolean;
    activeState: number;
    archivingType: number;
    archivingRemoveDate: number;
    modifyUser: IModifyUser;
}

export class InstantMessageChannelEditItem extends EditItem implements IInstantMessageChannelEditItem {
    companyId: string;
    code: string;
    picture: string;
    comment: string;
    messageExpirationTime: number;
    internalChannel: boolean;
    activeState: number;
    archivingType: number;
    archivingRemoveDate: number;
    modifyUser: ModifyUser;

    constructor();
    constructor(obj: IInstantMessageChannelEditItem);
    constructor(obj?: any) {
        super(obj);
        this.companyId = obj && obj.companyId || "";
        this.code = obj && obj.code || "";
        this.picture = obj && obj.picture || "";
        this.comment = obj && obj.comment || "";
        this.messageExpirationTime = obj && obj.messageExpirationTime || 0;
        this.internalChannel = obj && obj.internalChannel || false;
        this.activeState = obj && obj.activeState || 0;
        this.archivingType = obj && obj.archivingType || 0;
        this.archivingRemoveDate = obj && obj.archivingRemoveDate || 0;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}